import { OrderRatingsWrapper } from "./order-ratings.style";
import { OrderRatingsSection } from "./sections/order-ratings.section";

export const OrderRatingsPage = () => <OrderRatingsWrapper><OrderRatingsSection /></OrderRatingsWrapper>;
